export const CHART_OTHER_TITLE = 'Other'

export const PIE_CHART_PALETTE_LIGHT = ['#1C4ED8', '#BBC9F4']
export const PIE_CHART_PALETTE_DARK = ['#416DE6', '#BAC8F3']

export const PIE_CHART_NEGATIVE_PALETTE_LIGHT = ['#EF4444', '#FDC9C8']
export const PIE_CHART_NEGATIVE_PALETTE_DARK = ['#F24242', '#FDD4D3']

export const BAR_CHART_COLOR_LIGHT = '#4c74e7'
export const BAR_CHART_COLOR_DARK = '#416de7'

export const BAR_CHART_NEGATIVE_COLOR_LIGHT = '#EF4444'
export const BAR_CHART_NEGATIVE_COLOR_DARK = '#F24242'

export const BAR_CHART_SELECTED_COLOR_LIGHT = '#4438ca'
export const BAR_CHART_SELECTED_COLOR_DARK = '#a5b4fc'
export const BAR_CHART_SELECTED_SHADOW_COLOR_LIGHT = 'rgba(68, 56, 202, 0.85)'
export const BAR_CHART_SELECTED_SHADOW_COLOR_DARK = 'rgba(255, 255, 255, 0.5)'

export const BAR_CHART_SELECTED_NEGATIVE_COLOR_LIGHT = '#ed1c1c'
export const BAR_CHART_SELECTED_NEGATIVE_COLOR_DARK = '#FCA5A5'
export const BAR_CHART_SELECTED_NEGATIVE_SHADOW_COLOR_LIGHT =
  'rgba(237, 28, 28, 0.85)'
export const BAR_CHART_SELECTED_NEGATIVE_SHADOW_COLOR_DARK =
  'rgba(255, 255, 255, 0.5)'
